import React from "react";
import moment from "moment";

import { JOBS } from "../raw_cv.js";

class Experience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatDate(date) {
    return moment(date)
      .utcOffset(480)
      .format("MMMM YYYY");
  }

  render() {
    const jobs = JOBS;
    return (
      <section id="experience" className="experience">
        <div className="container clearfix">
          <div className="experience__heading_wrapper">
            <h3 id="experience-position" className="experience__desc">
              Experience
            </h3>
          </div>
          <div className="clearfix" />
          {jobs.map((job, index) => {
            const thumbnail = job.thumbnail || "./images/freelance.png";
            const endDate =
              job.endDate === "Present"
                ? job.endDate
                : this.formatDate(job.endDate);
            const startDate = this.formatDate(job.startDate);
            return (
              <div key={index} className="row experience__job">
                <div className="col-md-4 clearfix">
                  <div className="company">
                    <img
                      alt="logo"
                      className="experience__logo img-responsive img-rounded"
                      src={thumbnail}
                    />
                    <div className="experience__company_name">
                      {job.companyName}
                    </div>
                    <div>{job.country}</div>
                  </div>{" "}
                  {/* COMPANY END */}
                </div>
                {/* /.col-md-4 */}
                <div className="col-md-8">
                  <h4 className="experience__jobtitle">
                    {job.title} {job.title ? "-" : ""}{" "}
                    <span className="experience__dates">
                      {startDate} – {endDate}
                    </span>
                  </h4>
                  <ul>
                    {job.responsibilities.map((responsibility, respIndex) => {
                      return <li key={respIndex}>{responsibility}</li>;
                    })}
                  </ul>
                  {/*<div className="skills">
                    Skills: <span>javascript</span>
                  </div>*/}
                </div>
                {/* /.col-md-8 */}
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

export default Experience;
